module.exports = __webpack_public_path__ + "static/media/eco.c3e8d26e.png";